import { module as BaseModule } from "modujs"
import Lenis from "lenis"

export default class extends BaseModule {
  init() {
    const wrapper = this.el
    const content = document.querySelector("[data-scroll-content]")

    if (!content) return

    const lenis = new Lenis({ wrapper, content })

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf.bind(this))
    }

    requestAnimationFrame(raf.bind(this))
  }
}
